import ImageDisplayAndDelete from '../ImagesGeneral/ImagesDisplayAndDelete'
import ImageUpload from '../ImagesGeneral/ImageUpload'
import ErrorBox from '../../../general/ErrorBox'
import ImageDisplayDeleteAndUpload from '../ImagesGeneral/ImageDisplayDeleteAndUpload'

const ImagesDisplayAndUploadComponent = ({
    field,
    hasImage,
    imageType,
    imageSize,
    image,
    imagePosition,
    movieTitle,
    isDisabled,
    isUploading,
    errorMessages,
    textUnderDropzone,
    onUploadStart,
    onUploadEndSuccess,
    onUploadEndError,
    onDeleteStart,
    imagePositionX,
    hideAdditionalText,
    autoUpload,
    onResetErrorMessages
}) => (
    
    <div className="image-display-upload">
        {isUploading && <div className='overlay'>
            <div className="spinner"></div>
        </div>}
        {hasImage ? (
            (image.hasOwnProperty('id') && image.id) || imageType === 'logo' ? (
                <ImageDisplayAndDelete
                    isDisabled={isDisabled}
                    field={field}
                    image={image}
                    imageType={imageType}
                    imageSize={imageSize}
                    imagePosition={imagePosition}
                    imagePositionX={imagePositionX}
                    onDeleteImage={onDeleteStart}
                    />
                ) : (
                    <ImageDisplayDeleteAndUpload
                    isDisabled={isDisabled}
                    isUploading={isUploading}
                    replaceUploadAt={false}
                    field={field}
                    image={image}
                    imageType={imageType}
                    onDeleteImage={onDeleteStart}
                    movieTitle={movieTitle}
                    onUploadStart={onUploadStart}
                    onUploadEndSuccess={onUploadEndSuccess}
                    onUploadEndError={onUploadEndError}
                    onResetErrorMessages={onResetErrorMessages}
                />
            )
        ) : (
            <ImageUpload
                hideAdditionalText={hideAdditionalText}
                autoUpload={autoUpload}
                isDisabled={isDisabled}
                isUploading={isUploading}
                textUnderDropzone={textUnderDropzone}
                onUploadStart={onUploadStart}
                onUploadEndSuccess={onUploadEndSuccess}
                onUploadEndError={onUploadEndError}
                onResetErrorMessages={onResetErrorMessages}
            />
        )}

        <ErrorBox 
            messages={errorMessages}
        />
    </div>
)

export default ImagesDisplayAndUploadComponent